import { IdHelper } from '../../../../../../helpers/id.helper';

function CollapseWithLinkButton({
  linkText,
  className,
  children,
  ariaLive = undefined,
  onToggle = undefined,
}: {
  linkText: string;
  className?: string;
  children: React.ReactNode;
  ariaLive?: 'off' | 'assertive' | 'polite';
  onToggle?: () => void;
}) {
  // === VARIABLES ===
  const collapsibleId = IdHelper.newUniqueId('collapsible-area-');

  return (
    <div className={`collapse-with-link ${className ?? ''}`}>
      <button
        type="button"
        className="btn--as-link btn--with-caret position-relative pe-3 mb-3 collapsed"
        data-bs-toggle="collapse"
        data-bs-target={`#${collapsibleId}`}
        aria-expanded="false"
        aria-controls={collapsibleId}
        aria-live={ariaLive}
        onClick={onToggle}
      >
        {linkText}
      </button>
      <div className="collapse" id={collapsibleId}>
        {children}
      </div>
    </div>
  );
}

export default CollapseWithLinkButton;
